import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getData } from 'modules/activityDetails/AproDetails/api/aproDetailsService'
import { AproDetailsState, ApiAproDetailsResponse } from './types'

const initialState: AproDetailsState = {
  data: {},
}

const aproDetailsSlice = createSlice({
  name: 'aproDetails',
  initialState,
  reducers: {
    dataLoaded(state, action: PayloadAction<ApiMiddlewarePayload<ApiAproDetailsResponse>>) {
      state.data = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { dataLoaded } = aproDetailsSlice.actions

export default aproDetailsSlice.reducer

export const loadData = () => {
  return createApiAction({
    apiCalls: {
      info: getData,
    },
    payloadAction: dataLoaded,
  })
}
